<template>
    <div>
        <div class="palette fdc">
            <div class="palette_new">
              <span class="line"></span>
              <span class="palette_text">{{paletteObj.paletteTitle}}</span>
              <span v-if="paletteObj.isShow == true" :class="[paletteObj.paletteCount ==''?'dn':'palette_count']">（{{paletteObj.paletteCount}}）</span>
            </div>
            <div class="palette_kater  fdc">
              <button @click.prevent="onClick()">{{paletteObj.paletteName}}</button>
			        	<!--编辑-->
                <span v-if="paletteObj.isEdit == true"   @click.prevent="onEdit()">{{paletteObj.paletteView}}</span> 
                <!--删除-->
                <span v-if="paletteObj.isDelete == true"   @click.prevent="onDelete()">{{paletteObj.paletteText}}</span> 
                <p class="refresh_box" v-if="paletteObj.isView == true">
                <img src="../assets/images/refresh.png" alt="">
                <span @click.prevent="onView()"> 查看浏览记录</span>
                </p>
            </div> 
        </div>
    </div>
</template>
<script>
export default {
   props:["paletteObj"],
   data(){
     return{
     }
   },
   methods:{
      //添加
      onClick(){
        this.$emit('onPaletteBar')
      },
      //删除
      onDelete(){
         this.$emit('onDelPalet')
      },
      //查看
      onView(){
        this.$emit('onViewPalet')
      },
      //编辑
      onEdit(){
        this.$emit('onEditPalet')
      }
   } 
}
</script>
<style scoped>
.fdc{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.palette_new{
  margin-left: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.palette_text{
  margin-left: 15px; 
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.palette_count{ 
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 6px;
}
.line{
  width: 5px;
  height: 23px;
  background: #FF7302;
  display: inline-block;
}
.palette button{
  width: 93px;
  height: 27px;
  background: #FF7302;
  border-radius: 3px; 
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  margin-right: 20px;
  position: relative;
}
.palette button::before{
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 10px;
  margin-left: -40px;
  margin-top: -1px;
  border-top: 1px solid;

}
.palette button::after{
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  height: 10px;
  margin-left: -35.5px;
  margin-top: -5px;
  border-left: 1px solid;

}
.palette div:nth-child(2) span{
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9A9A9A;
}
.palette div:nth-child(2) span:hover{
  cursor: pointer;
  color: #FF7302 ;
}
.palette div:last-child span{
  margin-left: 10px;
}
.refresh_box{
  margin-left: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.refresh_box img{
   width: 15px;
   height: 15px;
   margin-right: -5px;
}
.refresh_box span{
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;

}
.dn{
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/common/paletteBar.vue